import { handleActions } from "redux-actions";
import actionCreators from "../../actions/top/follow_circle_list";

const initialState = {
  followCircles: [],
  loading: true,
};

export default handleActions(
  {
    [actionCreators.top.followcircles.set]: (state, action) =>
      Object.assign({}, state, action.payload),
    [actionCreators.top.followcircles.success]: (state, action) =>
      Object.assign({}, state, action.payload.data, { loading: false }),
    [actionCreators.top.followcircles.failure]: (state, action) =>
      Object.assign({}, state, {
        errorStatus: action.payload.error,
        loading: false,
      }),
  },
  initialState
);
